import L from "leaflet";

function createButton(container) {
  const button = L.DomUtil.create("a", "lock-zoom-button", container);
  button.href = "#";
  button.title = "Lås zoomnivå";
  button.innerHTML = "<span class='fa fa-lock'></span>";
  return button;
}

L.Control.LockZoom = L.Control.extend({
  options: {
    position: "bottomleft",
  },

  initialize(options) {
    L.Util.setOptions(this, options);
  },

  initContainer() {
    this._container = L.DomUtil.create(
      "div",
      "leaflet-control-zoom-lock leaflet-bar"
    );

    this._button = createButton(this._container);

    L.DomEvent.on(this._button, "dblclick", L.DomEvent.stop, this)
      .on(this._button, "click", L.DomEvent.stop, this)
      .on(this._button, "click", this._clickHandler, this);

    return this._container;
  },

  onAdd(map) {
    this._map = map;
    this._isLocked = false;
    this._map.on("baselayerchange", this._baselayerChangeHandler, this);

    return this.initContainer();
  },

  onRemove() {
    this._map.off("baselayerchange", this._baselayerChangeHandler, this);
  },

  _baselayerChangeHandler() {
    if (this._isLocked) {
      this._unlockZoom();
    }
  },
  _clickHandler() {
    if (this._isLocked) {
      this._unlockZoom();
    } else {
      this._lockZoom();
    }
  },

  _lockZoom() {
    this._isLocked = true;
    let currentZoomLevel = this._map.getZoom();

    this._map.eachLayer(function (layer) {
      layer.options.maxNativeZoom = currentZoomLevel;
      layer.options.minNativeZoom = currentZoomLevel;
    });

    this._map.setMinZoom(currentZoomLevel - 2);

    L.DomUtil.addClass(this._container, "locked");
  },

  _unlockZoom() {
    this._isLocked = false;

    this._map.eachLayer(function (layer) {
      layer.options.maxNativeZoom = undefined;
      layer.options.minNativeZoom = undefined;
    });

    this._map.setMinZoom(undefined);
    this._map._resetView(this._map.getCenter(), this._map.getZoom());

    L.DomUtil.removeClass(this._container, "locked");
  },
});

L.Control.lockZoom = () => new L.Control.LockZoom();

function initLockZoomControl(map) {
  L.Control.lockZoom().addTo(map);
}

export { initLockZoomControl };
